export default __webpack_public_path__ + "static/media/05.15d209dd.jpg";